
// import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
// import HomeTitle from "../components/HomeTitle/HomeTitle"
// import ExportBox from "../components/ExportBox/ExportBox"
// import Table from "../components/Table/Table"
// import { Container } from "react-bootstrap"
// import { useCallback, useEffect, useState } from "react"
// import axios from "axios"
// import { useSelector } from "react-redux"
// import CommonModal from "../components/CommonModa/CommonModal"

// function SchoolStructureStages() {
//     const userinfo = useSelector((state) => state);
//     const { currentLocal } = useSelector((state) => state.currentLocal);
//   const { stgeesArray } = useSelector((state) => state.stages);
//     const [items, setItems] = useState([])
//   const [showEdit, setShowEdit] = useState(false);
//   const [selectedItemSubject, setSelectedItemSubject] = useState(null);

//   const handleShowEdit = (item) => {
//     setSelectedItemSubject(item);
//     setShowEdit(true);
//   };
//      const getAllApis =useCallback(async () => {

//             await axios
//                 .get(`https://nanosoft.space/taarteb/public/api/grades`, {
//                     headers: {
//                         Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
//                     }
//                 })
//                 .then(async (res) => {
// console.log(res.data.data);

//                     setItems(res.data.data)


//                 })
//                 .catch((error) => {


//                 });
//         },[items])
//     useEffect(() => {

//         getAllApis()

//     }, [getAllApis])
//     const headerIterm = [
//         currentLocal.home.ID,
//         currentLocal.home.namePlaceholder,
//         ""
//     ]

//     const body=<tbody>

//     {stgeesArray?.map((item, index) => {

//       return (
//         <tr key={index}>
//           <td>{item?.value}</td>

//           <td>{item?.label}</td>
//       <td >

//                             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16" style={{ cursor: "pointer" }} onClick={() => handleShowEdit(item)}
//                           >
//                             <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
//                             <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
//                           </svg>


//                       </td>
// </tr>
//       )
//     })}

//       </tbody>

//   const handleCloseEdit = () => {
//     setShowEdit(false);
//     setSelectedItemSubject(null);
//   };

//     return (
//         <div className="px-0 my-3 w-100 dashboard_content">

//       {selectedItemSubject &&
//         <CommonModal
//           showEdit={showEdit}
//           handleClose={handleCloseEdit}
//           state={currentLocal.home.edit}
//           item={selectedItemSubject}
//           onDataChanged={[]}

//         />
//       }
//             <Container>
//                 <div className="d-flex flex-column w-100">
//                     <AuthNavbar />
//                     <div className="mt-5 mx-3">
//                         <HomeTitle title={currentLocal.home.stages} />
//                         <ExportBox
//                             title={""}
//                             paragrapg={' '}
//                             addingBtn={currentLocal.home.addStage}
//                             exportState={false}


//                         />



//                               <Table
//                                             data={items}
//                                             headerIterm={headerIterm}
//                                             actions={["edit"]}
//                                             body={body}
//                                             // onDataChanged={getAllApis}
//                                         />


//                     </div>

//                 </div>
//             </Container>
//         </div>
//     )
// }

// export default SchoolStructureStages



import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import ExportBox from "../components/ExportBox/ExportBox"
import Table from "../components/Table/Table"
import { Container } from "react-bootstrap"
import { useCallback, useEffect, useState } from "react"
import axios from "axios"
import { useSelector } from "react-redux"

function SchoolStructureStages() {
  const userinfo = useSelector((state) => state);
  const { currentLocal } = useSelector((state) => state.currentLocal);

  const [items, setItems] = useState([])

  const getAllApis = useCallback(async () => {

    await axios
      .get(`https://nanosoft.space/taarteb/public/api/grade-categories`, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      })
      .then(async (res) => {

        setItems(res.data.data.data)


      })
      .catch((error) => {


      });
  }, [items])
  useEffect(() => {

    getAllApis()

  }, [getAllApis])
  const headerIterm = [
    currentLocal.home.ID,
    currentLocal.home.namePlaceholder,
  ]
  return (
    <div className="px-0 my-3 w-100 dashboard_content">
      <Container>
        <div className="d-flex flex-column w-100">
          <AuthNavbar />
          <div className="mt-5 mx-3">
            <HomeTitle title={currentLocal.home.stages} />
            <ExportBox
              title={""}
              paragrapg={' '}
              addingBtn={currentLocal.home.addStage}
              exportState={false}


            />

            <Table
              data={items}
              headerIterm={headerIterm}
              onSubmitAttendance={() => { }}
              actions={['edit']}

            />


          </div>

        </div>
      </Container>
    </div>
  )
}

export default SchoolStructureStages
